import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    handleFetchInvoicesFulfilled,
    handleFetchInvoiceFixedIteamListFulfilled,
    handleFetchInvoiceGetBasePriceFulfilled,
    handleFetchPromotionListFulfilled,
    handleCalculatePriceFulfilled,
    handleAddContractInvoiceFulfilled,
    handleFetchInvoiceStatusFulfilled,
    handleFetchInvoiceDetailsFulfilled,
    handleFetchContractGlobalStatusListFulfilled,
    handleFetchInvoiceActivityLogListFulfilled,
    handleUpdatePaymentInvoiceFulfilled,
    handleFetchReservationFeeFulfilled,
    handleUploadInvoicePaymentAttachmentFulfilled
} from './invoicesExtraReducers';
import { handlePending, handleRejected } from '../common/extra-reducers/commonExtraReducers';
import { getInvoices, getInvoicesFixedItemList, invoicesGetBasePrice, promotionListByWorker, getCalculatePrice, setContractInvoice, getInvoiceStatus, getInvoiceDetails, getContractGlobalStatusList, getInvoiceActivityLogList, setUpdatePaymentInvoice, getReservationFee, saveUploadInvoicePaymentAttachment, getActionStatusList, changeInvoiceStatus, invoiceGLobalCancellationReason, refundInvoice, addInvoiceExchange, updateAdjustPaymentInvoice, getPolicies, saveInsurance, saveInsuranceInvoice, getInsuranceDetails, getInsuranceList, getInsuranceActivityLog, saveInsuranceActivated, updateInsuranceData, updateInsuranceStatusApi, getPoliciesEndorsmentList, checkPolicyNumber, saveInsuranceEndorsement, updateStatusEndorsement, getInsuranceStatusList, saveGeneralInvoice, updatePaymentFollowUpAPI } from '../../../services/invoices';

export const fetchInvoices = createAsyncThunk('invoices/fetchInvoices', async (reqPayload) => {
    const response = await getInvoices(reqPayload);
    return response.data.data;
});

export const fetchInvoicesFixedItemList = createAsyncThunk('invoices/fetchInvoicesFixedItemList', async (reqPayload) => {
    const response = await getInvoicesFixedItemList(reqPayload);
    return response.data.data;
});

export const fetchInvoicesGetBasePrice = createAsyncThunk('invoices/fetchInvoicesGetBasePrice', async (reqPayload) => {
    const response = await invoicesGetBasePrice(reqPayload);
    return response.data.data;
});

export const fetchPromotionListByWorker = createAsyncThunk('invoices/fetchPromotionListByWorker', async (reqPayload) => {
    const response = await promotionListByWorker(reqPayload);
    return response.data.data;
});

export const fetchCalculatePrice = createAsyncThunk('invoices/fetchCalculatePrice', async (reqPayload) => {
    const response = await getCalculatePrice(reqPayload);
    return response.data.data;
});

export const addContractInvoice = createAsyncThunk('invoices/addContractInvoice', async (reqPayload) => {
    try {
        const response = await setContractInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const addGeneralInvoice = createAsyncThunk('invoices/addGeneralInvoice', async (reqPayload) => {
    try {
        const response = await saveGeneralInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchInvoiceStatus = createAsyncThunk('invoices/fetchInvoiceStatus', async (reqPayload) => {
    try {
        const response = await getInvoiceStatus(reqPayload);
        return response;
    } catch (error) {
        return error.response;
    }
});

export const fetchInvoiceDetails = createAsyncThunk('invoices/fetchInvoiceDetails', async (reqPayload) => {
    const response = await getInvoiceDetails(reqPayload);
    return response.data;
});

export const fetchContractGlobalStatusList = createAsyncThunk('invoices/fetchContractGlobalStatusList', async (reqPayload) => {
    try {
        const response = await getContractGlobalStatusList(reqPayload);
        return response;
    } catch (error) {
        return error.response;
    }
});

export const fetchInvoiceActivityLogList = createAsyncThunk('invoices/fetchInvoiceActivityLogList', async (reqPayload) => {
    try {
        const response = await getInvoiceActivityLogList(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const updatePaymentInvoice = createAsyncThunk('invoices/updatePaymentInvoice', async (reqPayload) => {
    try {
        const response = await setUpdatePaymentInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchReservationFee = createAsyncThunk('invoices/fetchReservationFee', async (reqPayload) => {
    try {
        const response = await getReservationFee(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const uploadInvoicePaymentAttachment = createAsyncThunk('invoices/uploadInvoicePaymentAttachment', async (reqPayload) => {
    try {
        const response = await saveUploadInvoicePaymentAttachment(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});


export const fetchActionStatusList = createAsyncThunk('invoices/fetchActionStatusList', async (reqPayload) => {
    try {
        const response = await getActionStatusList(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const saveChangeInvoiceStatus = createAsyncThunk('invoices/changeInvoiceStatus', async (reqPayload) => {
    try {
        const response = await changeInvoiceStatus(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchInvoiceGLobalCancellationReason = createAsyncThunk('invoices/fetchInvoiceGLobalCancellationReason', async (reqPayload) => {
    try {
        const response = await invoiceGLobalCancellationReason(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});


export const addRefundInvoice = createAsyncThunk('invoices/addRefundInvoice', async (reqPayload) => {
    try {
        const response = await refundInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const saveInvoiceExchange = createAsyncThunk('invoices/saveInvoiceExchange', async (reqPayload) => {
    try {
        const response = await addInvoiceExchange(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const saveUpdateAdjustPaymentInvoice = createAsyncThunk('invoices/saveUpdateAdjustPaymentInvoice', async (reqPayload) => {
    try {
        const response = await updateAdjustPaymentInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchPolicies = createAsyncThunk('invoices/fetchPolicies', async (reqPayload) => {
    const response = await getPolicies(reqPayload);
    return response.data.data;
});

export const addInsurance = createAsyncThunk('invoices/addInsurance', async (reqPayload) => {
    try {
        const response = await saveInsurance(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const addInsuranceInvoice = createAsyncThunk('invoices/addInsuranceInvoice', async (reqPayload) => {
    try {
        const response = await saveInsuranceInvoice(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchInsuranceDetails = createAsyncThunk('invoices/fetchInsuranceDetails', async (reqPayload) => {
    const response = await getInsuranceDetails(reqPayload);
    return response.data;
});

export const fetchInsuranceList = createAsyncThunk('invoices/fetchInsuranceList', async (reqPayload) => {
    const response = await getInsuranceList(reqPayload);
    return response.data.data;
});

export const fetchInsuranceActivityLog = createAsyncThunk('invoices/fetchInsuranceActivityLog', async (reqPayload) => {
    const response = await getInsuranceActivityLog(reqPayload);
    return response.data.data;
});

export const addInsuranceActivated = createAsyncThunk('invoices/addInsuranceActivated', async (reqPayload) => {
    try {
        const response = await saveInsuranceActivated(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const updateStatusInsuranceEndorsement = createAsyncThunk('invoices/updateStatusInsuranceEndorsement', async (reqPayload) => {
    try {
        const response = await updateStatusEndorsement(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const updateInsurance = createAsyncThunk('invoices/updateInsurance', async (reqPayload) => {
    try {
        const response = await updateInsuranceData(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const updateInsuranceStatus = createAsyncThunk('invoices/updateInsuranceStatus', async (reqPayload) => {
    try {
        const response = await updateInsuranceStatusApi(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchPoliciesAdditionalCoverage = createAsyncThunk('invoices/fetchPoliciesAdditionalCoverage', async (reqPayload) => {
    const response = await getPolicies(reqPayload);
    return response.data.data;
});

export const fetchPoliciesEndorsmentList = createAsyncThunk('invoices/fetchPoliciesEndorsmentList', async (reqPayload) => {
    const response = await getPoliciesEndorsmentList(reqPayload);
    return response.data.data;
});

export const fetchPolicyNumber = createAsyncThunk('invoices/fetchPolicyNumber', async (reqPayload) => {
    const response = await checkPolicyNumber(reqPayload);
    return response.data.data;
});

export const addInsuranceEndorsement = createAsyncThunk('invoices/addInsuranceEndorsement', async (reqPayload) => {
    try {
        const response = await saveInsuranceEndorsement(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const updatePaymentFollowUp = createAsyncThunk('invoices/updatePaymentFollowUp', async (reqPayload) => {
    try {
        const response = await updatePaymentFollowUpAPI(reqPayload);
        return response.data;
    } catch (error) {
        return error.response;
    }
});

export const fetchInsuranceStatusList = createAsyncThunk('invoices/fetchInsuranceStatusList', async (reqPayload) => {
    const response = await getInsuranceStatusList(reqPayload);
    return response.data.data;
});


const invoicesSlice = createSlice({
    name: 'invoices',
    initialState: {
        invoices: [],
        insuranceList: [],
        invoicesOrder: [],
        invoicesFixedItemList: [],
        invoiceActivityLogList: [],
        actionStatusList: [],
        invoiceCacellationReason: [],
        insuranceActivityLogList: [],
        policiesList: [],
        additionalCoverageList: [],
        endorsementList: [],
        promotionList: [],
        contractGLobalList: "",
        invoicesBasePrice: {},
        reservationFee: {},
        calculatePrice: {},
        invoiceDetails: {},
        insuranceDetails: {},
        policyNumberInfo: {},
        invoiceStatus: [],
        insuranceStatusList: [],
        status: 'success',
        error: null,
        currentInvoices: null,
        currentPage: 1,
        perPage: 10,
        totalPages: 0,
        total: 0,
        lastUpdated: '',
        message: null,
        currentInvoiceExchange: null,
        filtersData: {},
        insuranceFiltersData: {},
        invoiceContractDataState: {},
    },
    reducers: {
        clearMessage(state) {
            state.message = null;
        },
        setFilters(state, action) {
            state.filtersData = action.payload;
        },
        clearFilters(state) {
            state.filtersData = {};
        },
        setInsuranceFilters(state, action) {
            state.insuranceFiltersData = action.payload;
        },
        setCurrentInvoiceExchange(state, action) {
            state.currentInvoiceExchange = action.payload;
        },
        clearCurrentInvoiceExchange(state) {
            state.currentInvoiceExchange = null;
        },
        clearInvoiceDetails(state) {
            state.invoiceDetails = {};
        },
        setInvoiceContractDataState(state, action) {
            state.invoiceContractDataState = action.payload;
        },
        clearInvoiceContractDataState(state) {
            state.invoiceContractDataState = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInvoices.pending, handlePending)
            .addCase(fetchInvoices.fulfilled, handleFetchInvoicesFulfilled)
            .addCase(fetchInvoices.rejected, handleRejected)
            .addCase(fetchInvoicesFixedItemList.pending, handlePending)
            .addCase(fetchInvoicesFixedItemList.fulfilled, handleFetchInvoiceFixedIteamListFulfilled)
            .addCase(fetchInvoicesFixedItemList.rejected, handleRejected)
            .addCase(fetchInvoicesGetBasePrice.pending, handlePending)
            .addCase(fetchInvoicesGetBasePrice.fulfilled, handleFetchInvoiceGetBasePriceFulfilled)
            .addCase(fetchInvoicesGetBasePrice.rejected, handleRejected)
            .addCase(fetchPromotionListByWorker.pending, handlePending)
            .addCase(fetchPromotionListByWorker.fulfilled, handleFetchPromotionListFulfilled)
            .addCase(fetchPromotionListByWorker.rejected, handleRejected)
            .addCase(fetchCalculatePrice.pending, handlePending)
            .addCase(fetchCalculatePrice.fulfilled, handleCalculatePriceFulfilled)
            .addCase(fetchCalculatePrice.rejected, handleRejected)
            .addCase(addContractInvoice.pending, handlePending)
            .addCase(addContractInvoice.fulfilled, handleAddContractInvoiceFulfilled)
            .addCase(addContractInvoice.rejected, handleRejected)
            .addCase(fetchInvoiceStatus.pending, handlePending)
            .addCase(fetchInvoiceStatus.fulfilled, handleFetchInvoiceStatusFulfilled)
            .addCase(fetchInvoiceStatus.rejected, handleRejected)
            .addCase(fetchInvoiceDetails.pending, handlePending)

            .addCase(fetchInvoiceDetails.fulfilled, handleFetchInvoiceDetailsFulfilled)
            .addCase(fetchInvoiceDetails.rejected, handleRejected)
            .addCase(fetchContractGlobalStatusList.pending, handlePending)
            .addCase(fetchContractGlobalStatusList.fulfilled, handleFetchContractGlobalStatusListFulfilled)
            .addCase(fetchContractGlobalStatusList.rejected, handleRejected)
            .addCase(fetchInvoiceActivityLogList.pending, handlePending)
            .addCase(fetchInvoiceActivityLogList.fulfilled, handleFetchInvoiceActivityLogListFulfilled)
            .addCase(fetchInvoiceActivityLogList.rejected, handleRejected)
            .addCase(updatePaymentInvoice.pending, handlePending)
            .addCase(updatePaymentInvoice.fulfilled, handleUpdatePaymentInvoiceFulfilled)
            .addCase(updatePaymentInvoice.rejected, handleRejected)
            .addCase(fetchReservationFee.pending, handlePending)
            .addCase(fetchReservationFee.fulfilled, handleFetchReservationFeeFulfilled)
            .addCase(fetchReservationFee.rejected, handleRejected)
            .addCase(uploadInvoicePaymentAttachment.pending, handlePending)
            .addCase(uploadInvoicePaymentAttachment.fulfilled, handleUploadInvoicePaymentAttachmentFulfilled)
            .addCase(uploadInvoicePaymentAttachment.rejected, handleRejected)
            .addCase(fetchActionStatusList.pending, handlePending)
            .addCase(fetchActionStatusList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.actionStatusList = action.payload.data;
            })
            .addCase(fetchActionStatusList.rejected, handleRejected)
            .addCase(saveChangeInvoiceStatus.pending, handlePending)
            .addCase(saveChangeInvoiceStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload.message;
            })
            .addCase(saveChangeInvoiceStatus.rejected, handleRejected)
            .addCase(fetchInvoiceGLobalCancellationReason.pending, handlePending)
            .addCase(fetchInvoiceGLobalCancellationReason.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.invoiceCacellationReason = action.payload.data;
            })
            .addCase(fetchInvoiceGLobalCancellationReason.rejected, (state) => {
                state.invoiceCacellationReason = [];
            })
            .addCase(addRefundInvoice.pending, handlePending)
            .addCase(addRefundInvoice.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload.message;
            })
            .addCase(addRefundInvoice.rejected, handleRejected)
            .addCase(saveInvoiceExchange.pending, handlePending)
            .addCase(saveInvoiceExchange.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(saveInvoiceExchange.rejected, handleRejected)
            .addCase(saveUpdateAdjustPaymentInvoice.pending, handlePending)
            .addCase(saveUpdateAdjustPaymentInvoice.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(saveUpdateAdjustPaymentInvoice.rejected, handleRejected)
            .addCase(fetchPolicies.pending, handlePending)
            .addCase(fetchPolicies.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.policiesList = action.payload;
            })
            .addCase(fetchPolicies.rejected, handleRejected)
            .addCase(addInsurance.pending, handlePending)
            .addCase(addInsurance.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                // if (action.payload.data.insurance)
                //     state.insuranceList.unshift(action.payload.data.insurance);
            })
            .addCase(addInsurance.rejected, handleRejected)
            .addCase(addInsuranceInvoice.pending, handlePending)
            .addCase(addInsuranceInvoice.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(addInsuranceInvoice.rejected, handleRejected)
            .addCase(fetchInsuranceDetails.pending, handlePending)
            .addCase(fetchInsuranceDetails.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.insuranceDetails = action.payload;
            })
            .addCase(fetchInsuranceDetails.rejected, handleRejected)
            .addCase(fetchInsuranceList.pending, handlePending)
            .addCase(fetchInsuranceList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.insuranceList = action.payload.data;
                state.currentPage = action.payload.current_page;
                state.perPage = action.payload.limit;
                state.totalPages = action.payload.total_pages;
                state.total = action.payload.total_count;
                state.lastUpdated = action.payload.last_updated;
            })
            .addCase(fetchInsuranceList.rejected, handleRejected)
            .addCase(fetchInsuranceActivityLog.pending, handlePending)
            .addCase(fetchInsuranceActivityLog.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.insuranceActivityLogList = action.payload;
            })
            .addCase(fetchInsuranceActivityLog.rejected, handleRejected)
            .addCase(addInsuranceActivated.pending, handlePending)
            .addCase(addInsuranceActivated.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(addInsuranceActivated.rejected, handleRejected)
            .addCase(updateInsurance.pending, handlePending)
            .addCase(updateInsurance.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(updateInsurance.rejected, handleRejected)
            .addCase(updateInsuranceStatus.pending, handlePending)
            .addCase(updateInsuranceStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(updateInsuranceStatus.rejected, handleRejected)
            .addCase(fetchPoliciesAdditionalCoverage.pending, handlePending)
            .addCase(fetchPoliciesAdditionalCoverage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.additionalCoverageList = action.payload;
            })
            .addCase(fetchPoliciesAdditionalCoverage.rejected, handleRejected)
            .addCase(fetchPoliciesEndorsmentList.pending, handlePending)
            .addCase(fetchPoliciesEndorsmentList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.endorsementList = action.payload;
            })
            .addCase(fetchPoliciesEndorsmentList.rejected, handleRejected)
            .addCase(fetchPolicyNumber.pending, handlePending)
            .addCase(fetchPolicyNumber.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.policyNumberInfo = action.payload;
            })
            .addCase(fetchPolicyNumber.rejected, handleRejected)
            .addCase(addInsuranceEndorsement.pending, handlePending)
            .addCase(addInsuranceEndorsement.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(addInsuranceEndorsement.rejected, handleRejected)
            .addCase(updatePaymentFollowUp.pending, handlePending)
            .addCase(updatePaymentFollowUp.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(updatePaymentFollowUp.rejected, handleRejected)
            .addCase(updateStatusInsuranceEndorsement.pending, handlePending)
            .addCase(updateStatusInsuranceEndorsement.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
            })
            .addCase(updateStatusInsuranceEndorsement.rejected, handleRejected)
            .addCase(fetchInsuranceStatusList.pending, handlePending)
            .addCase(fetchInsuranceStatusList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.insuranceStatusList = action.payload;
            })
            .addCase(fetchInsuranceStatusList.rejected, handleRejected)
            .addCase(addGeneralInvoice.pending, handlePending)
            .addCase(addGeneralInvoice.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(addGeneralInvoice.rejected, handleRejected);
    },
});

export const { clearMessage, setCurrentInvoiceExchange, clearCurrentInvoiceExchange, clearInvoiceDetails, setFilters, clearFilters, setInsuranceFilters, setInvoiceContractDataState, clearInvoiceContractDataState } = invoicesSlice.actions;

export default invoicesSlice.reducer;
